module.exports = __webpack_public_path__ + "img/MC3.f069461a.webp";